/**
 * book_offers refetch interval
 */
export const ORDERS_REFETCH_INTERVAL = 3000;

/**
 * open_orders refetch interval
 */
export const OPEN_ORDERS_REFETCH_INTERVAL = 2500;

/**
 * Decimal places for prices in the order book
 */
export const DECIMAL_PLACES = 6;
